// 企业邮件配置
export const EmailService = {
  'ausnutria.com': {
    // 总部
    corpid: 'wmfceba37212a2291b', // 在QQ企业邮箱应用中心获取
    newMailSecret:
      'jDL-HOKThG1ApHlB7B9s6l9qb6DmXKw2qQkE47N-W4EFlaSRSnaFxPOEueDoGjWH', // 应用中心 新邮件提醒
    SSOSecret:
      'waUFRxAOmdudQkp9VIypN1zR9TS-3ZN1Xu2I4eh3IxaK65Ni0v0oGbSA5JAVm3id', // 应用中心 单点登录
    apiUrl: 'https://api.exmail.qq.com/cgi-bin/',
    testUserId: 'nldit@ausnutria.com', //  测试阶段使用，正式发布时请修改为获取当前账户关联的 email
    testUserPwd: 'Au2018' // 关联的email密码
  },
  'kabrita.com.cn': {
    // 佳贝艾特与 hyproca.com
  },
  'puredo.com': {
    corpid: 'wm345f936ae3044569', // 在QQ企业邮箱应用中心获取
    newMailSecret:
      'yz_9TcFX7z8DMdltHW2nayLNwTfxKCZARnHzefyzOiZvd2G_pDRF5Pet-L3AjDKE', // 应用中心 新邮件提醒
    SSOSecret:
      'wIS4Ww1SjutJ6vqi63FfQ-oshD_MjyZQ2vt0j5UF5-MKpC-WVp0kuuLMxvL-Ywk1', // 应用中心 单点登录
    apiUrl: 'https://api.exmail.qq.com/cgi-bin/',
    testUserId: 'it@puredo.com', //  测试阶段使用，正式发布时请修改为获取当前账户关联的 email
    testUserPwd: 'Au2018' // 关联的email密码
  },
  'allnutria.com': {
    // 能力多 使用总部邮件
    corpid: '',
    newMailSecret: '',
    SSOSecret: '',
    apiUrl: 'https://api.exmail.qq.com/cgi-bin/',
    testUserId: '',
    testUserPwd: ''
  },
  'globlait.com': {
    corpid: '', // 在QQ企业邮箱应用中心获取
    newMailSecret: '', // 应用中心 新邮件提醒
    SSOSecret: '', // 应用中心 单点登录
    apiUrl: 'https://api.exmail.qq.com/cgi-bin/',
    testUserId: '', //  测试阶段使用，正式发布时请修改为获取当前账户关联的 email
    testUserPwd: '' // 关联的email密码
  },
  '1897.com': {
    corpid: 'wm01beee44a8f632ed', // 在QQ企业邮箱应用中心获取
    newMailSecret:
      'oRtIDc8wmXV05tLZxzdfTM_P6SKWNvdLyhibmNG__MKOAiwCcX1zShiuPI5hOTzP', // 应用中心 新邮件提醒
    SSOSecret:
      'xqvnwaZtBM9tPU5eVwpvwdU3qR5gCwL7_njGBDU-bZLk2B5Z5DQ-TDUfTLjwQnF1', // 应用中心 单点登录
    apiUrl: 'https://api.exmail.qq.com/cgi-bin/',
    testUserId: 'csyx@1897.com', //  测试阶段使用，正式发布时请修改为获取当前账户关联的 email
    testUserPwd: 'Hp2018' // 关联的email密码
  },
  'hyproca.com': {
    domain: 'hyproca.com', // 网易邮箱
    priKey:
      '30820276020100300d06092a864886f70d0101010500048202603082025c0201000281810095715ecd1ab63b247872977fd0db92fa65dbe751eba3b0febdf8e39cdcbc81d925c288116508a353013eed1e8caf8c0ee3308cf67c4433ba286b9e987880a9cb04fe52d8b26b8b5cf53b12689be2be28675492919dd0cd87c56a10b278d18deb5f1dc62edaa63012d2b4919b18239021d62f5366e848cfeaf6a99e46f68babc102030100010281807cfef66c578b54ac8c924c657c2c2c23844f0a8c5aabefbf22e6aa7ae9a642757e3fd7cfb4d224c9a8a1197413f8410db2b9492e61822a41eacd193a2e906f7338cb4c5f870588bb87000e4389c2e6aadb105e4bcf4adfa1922fc7599eaf3c3779b02f01d6340719d8785c6f01e250883b339d62b96afa170e2ec2ec9ffa4881024100c8a441234cc090224683c5c8e8f77d24a922f459c6a65bf3c3c22178ec5e3c7954dac6a621bb937e662849613fb0f232c6fcd96041c1277af2c82ffea7f3b6ff024100beacd67a468f42a8c01282db10e3dabace34efd54ae14b8f96def5e7ec5a62736ea73c4631dd7918af6a1c676f2841ad3fa30b2ebead13e11b50fc9376e95d3f0241008681cf053a2c11b458af784593206f2dc7919e5c1d1763a78c81b56cda90e65bb4ae21e437d30733028b597e2f73913ac739b50499b042a662e21f82c9d751c3024006e8ee90d9d3c13faa4e416dbcebf4f64618c7043cc5735e8dc220b939e8809edc48b5377a0123ad505611177280cbf88250df4bdf5f18545510174724cd0a33024068c431ea671151af8fc00a0e1e127520ee4ca1e9b600399ceb18ecce6f4b08bb2845bf5c12f6df653d79b869a723c83d529b38a738912a3507070c55e4b7aa1d',
    pubKey:
      '30819f300d06092a864886f70d010101050003818d003081890281810095715ecd1ab63b247872977fd0db92fa65dbe751eba3b0febdf8e39cdcbc81d925c288116508a353013eed1e8caf8c0ee3308cf67c4433ba286b9e987880a9cb04fe52d8b26b8b5cf53b12689be2be28675492919dd0cd87c56a10b278d18deb5f1dc62edaa63012d2b4919b18239021d62f5366e848cfeaf6a99e46f68babc10203010001',
    newMailApi: 'https://cm.qiye.163.com/oaserver/user/getUnreadMsg',
    SSOApi: 'https://entry.qiye.163.com/domain/oa/Entry',
    testUserId: 'it@hyproca.com', //  测试阶段使用，正式发布时请修改为获取当前账户关联的 email
    testUserPwd: 'Aa147258', // 关联的email密码
    mailType: '163'
  }
};

export const Global = {
  newMailLoop: 1000 * 30 // 新邮件查询时长30秒
};
export const md5Config = {
  prefix: '', // md5加密的前缀字符串
  suffix: 'lo0.1l@g9v#' // md5加密的后缀字符串
};



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/webconfig.ts